import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { GetNameByIdPipe } from "./pipes/get-name-by-id.pipe";

import { ToastrModule } from "ngx-toastr";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { BsDatepickerModule, DatepickerModule } from "ngx-bootstrap/datepicker";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { ContactUsComponent } from "./components/contact-us/contact-us.component"; // import { AngularFontAwesomeModule } from 'angular-font-awesome';

import { DataTablesModule } from "angular-datatables";

import { TranslateModule } from "@ngx-translate/core";
import { ChatBoxComponent } from "./components/chat-box/chat-box.component";
import { NotifyComponent } from "./components/notify/notify.component";
import { FileSizePipe } from "./pipes/file-size.pipe";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { CalendarModule } from "primeng/calendar";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { PopoverModule } from "ngx-bootstrap/popover";
import { AutofocusDirective } from './directives/autofocus.directive';
import { DebounceClickDirective } from './directives/debounce-click.directive';

@NgModule({
  declarations: [
    GetNameByIdPipe,
    ContactUsComponent,
    ChatBoxComponent,
    NotifyComponent,
    FileSizePipe,
    AutofocusDirective,
    DebounceClickDirective
  ],
  imports: [
    TooltipModule,
    PopoverModule,
    TranslateModule,
        
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    GetNameByIdPipe,
    FileSizePipe,

    ContactUsComponent,
    ChatBoxComponent,
    NotifyComponent,

    AutofocusDirective,
    DebounceClickDirective,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // AngularFontAwesomeModule,

    //ngx-bootstrap
    CollapseModule,
    ToastrModule,
    BsDatepickerModule,
    DatepickerModule,
    TimepickerModule,
    BsDropdownModule,

    PaginationModule,
    TooltipModule,
    PopoverModule,
    TypeaheadModule,

    DataTablesModule,

    TranslateModule,

    CalendarModule,
  ],
})
export class SharedModule {}
